import '../../../lib/assets/javascripts/swipe';
import '../application/information/teachers.coffee';
import '../application/information/teachers/document_info.coffee';
import '../application/information/teachers/teacher_account_request_confirmation_popup.coffee';
import '../application/information/tests.js';
import '../application/information/gamification.coffee';
import '../application/information/homework_chat.coffee';
import '../application/information/worksheets.js';
import '../application/information/infopage_testimonials.js';
import '../application/information/videos.js';
import '../application/information/teachers/features_page/animation.js';
import '../application/videos/tracking.js';

import '../application/information/information.sass';
import '../application/information/teachers.sass';

import '../application/components/swipe_carousel.coffee';
import '../application/information/chatDummy.coffee';

import '../application/components/conversion/conversion_bars.sass';

import '../application/account_request/school_account_request.coffee';
import '../application/information/teachers/registry_contained_labels.js';
import '../application/information/teachers/scroll_to_form.js';
import '../application/account_request/account_request.sass';
import '../application/information/startchancen.js';
import '../application/information/sofabuddy_guidance.js';
import '../application/content_structure/chatbot_consent_banner.js';
